import { ref } from 'vue'
import { defineStore } from 'pinia'
import { apiClientV1, type ApiError } from '@/ContextTab/services/apiClient'
import type { DataOfNewsEventListGetOut } from '@/api/generated/v1'


const LIMIT = 100

// история работы над конкретной новостью
export const useNewsItemHistoryStore = defineStore('newsItemHistory', () => {

  const newsHistory = ref<DataOfNewsEventListGetOut[] | null>(null)
  const isFetching = ref(false)
  const error = ref<ApiError[] | null>(null)

  async function loadHistoryNews(newsId: number) {
    isFetching.value = true

    const response = await apiClientV1.NewsService.getNewsByNewsIdEvents({
      path: {
        news_id: newsId,
      },
      query: {
        limit: LIMIT,
      },
    }).finally(() => isFetching.value = false)

    if (!response.error) {
      newsHistory.value = response.data.data || null
    } else {
      error.value = response.error?.errors
    }
  }

  return {
    newsHistory,
    isFetching,
    error,

    loadHistoryNews,
  }
})
